import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { PermissionService } from '../services/permission.service';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AnalyzerProGuard implements CanActivate {
  constructor(private permissions: PermissionService, private auth: AuthService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    if (!this.auth.isLoggedIn()) {
      this.auth.login();
      return of(false);
    }
    this.permissions.ensureFresh();
    return of(
      this.permissions.hasAny(['analyzer-pro', 'downloader-pro', 'demo'])
        ? true
        : this.router.createUrlTree(['/ppk-studio'])
    );
  }
}


